// Guest user login page on element block
if(document.querySelector('.block__main_guestlogin_wrapper')){
    let quote_product_added_popup = localStorage.getItem("quoteProduct");

    if(quote_product_added_popup == "" || quote_product_added_popup == '[]' || quote_product_added_popup == null){
        document.querySelector('.block__main_guestlogin_wrapper').style.display = 'none';
    }else{
        document.querySelector('.block__main_guestlogin_wrapper').style.display = 'block';
    }
}
// Guest user button click on open form
if(document.querySelector('.guestlogin-btnform')){
    document.querySelector('.guestlogin-btnform').addEventListener("click", function(event) {
        event.preventDefault();
        let productsquoteDrawer = document.querySelector('.requestquote-drawer');
        if(productsquoteDrawer){
            productsquoteDrawer.classList.add('quotedrawer_active');
            document.body.classList.add('body_quotedrawer_active');
            document.querySelector('.requestquote-drawer .block__main_login-form').style.display = 'none';
            document.querySelector('.requestquote-drawer .login_guest_description').style.display = 'block';
            document.getElementById('quote-guestaccount').style.display = 'block';
        }else{}
    })
}


//Guset user login submitted code
if(document.getElementById("getProductIdsButton")){
    document.getElementById("getProductIdsButton").addEventListener("click", function(event) {
        let customerName = document.getElementById("customerName");
        let customerEmail = document.getElementById("customerEmail");
        let customerNamevalue = document.getElementById("customerName").value;
        let customerEmailvalue = document.getElementById("customerEmail").value;
        let customerCountry = document.getElementById("customerCountry").value;
        let tags = document.getElementById("tags").value;
        let salesperson = document.getElementById("salesperson").value;
        const nameError = document.getElementById('nameError');
        const emailError = document.getElementById('emailError');

        if(customerNamevalue != '' && customerEmailvalue != ''){
            event.preventDefault();
        }else{
            return;
        }
        const nameRegex = /^[A-Za-z\s]+$/;
        customerName.addEventListener('input', () => {
            const namevalue = customerName.value.trim(); // Remove leading/trailing spaces for check
            const isValidPattern = nameRegex.test(namevalue);
            const hasLetter = /[A-Za-z]/.test(namevalue); // Ensure at least one letter
            const isValid = isValidPattern && hasLetter && namevalue.length > 0;
            nameError.style.display = isValid ? 'none' : 'block';
            customerName.setCustomValidity(isValid ? '' : 'Invalid name: Must contain at least one letter.');
        });

        customerEmail.addEventListener('input', () => {
            const isValid = customerEmail.checkValidity();
            emailError.style.display = isValid ? 'none' : 'block';
            customerEmail.setCustomValidity(isValid ? '' : 'Invalid email');
        });

        const namevalue = customerName.value.trim();
        const isValidPattern = nameRegex.test(namevalue);
        const hasLetter = /[A-Za-z]/.test(namevalue);
        const isNameValid = isValidPattern && hasLetter && namevalue.length > 0;

        const isEmailValid = customerEmail.checkValidity();

        if (!isNameValid) {
            nameError.style.display = 'block';
            customerName.setCustomValidity('Invalid name');
            if (customerName) {
                customerName.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        } else {
            nameError.style.display = 'none';
            customerName.setCustomValidity('');
        }

        if (!isEmailValid) {
            emailError.style.display = 'block';
            customerEmail.setCustomValidity('Invalid email');
            if (customerEmail) {
                customerEmail.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        } else {
            emailError.style.display = 'none';
            customerEmail.setCustomValidity('');
        }

        if (isNameValid && isEmailValid) {          
        }else{
            return;
        }

        let products = [];

        document.querySelectorAll('.quotepopup-product-item').forEach(item => {
        let variantId = item.querySelector('.itemvariantid')?.value || "";
        let quantity = item.querySelector('.itemqty')?.value || "";
        let price = item.querySelector('.itemprice')?.value || "";

        if (variantId !== '') {
            products.push({
            variantId: variantId,
            quantity: quantity,
            price: price
            });
        }
        });

        const dataToSend = {
        customerName: customerNamevalue,
        customerEmail: customerEmailvalue,
        customerCountry: customerCountry,
        tags: tags,
        salesperson: salesperson,
        products: products
        };

        // Assuming dataToSend is defined elsewhere (e.g., an object with quote data)
        $.ajax({
            type: 'POST',
            url: 'https://app.valuetronics.com/requestquotewithoutlogin.php',
            data: JSON.stringify(dataToSend),
            dataType: 'json',
            success: function(response) {
            console.log("Success:", response.message);
            //alert(response.message);
            if(response.message == "Draft order Created successfully."){
                $('.requestquote-customerform-wrapper').hide();
                $('.thankyou-section .quote-error-icon').hide();
                $('.thankyou-section .quote-success-icon').show();
                $('.thankyou-section').addClass('show-thankyou-block');
                $('.quotepopup-section').css('display','none').addClass('empty-quotesection');
                $('#quoteproduct-listform').addClass('quote-products-hide').css('display','none');
                $('.quotedrawer-product-mainheading').css('display','none');
                $('.quotedrawer-product-submittedcontent').addClass('quote-submit-active').css('display','block');
                localStorage.removeItem("quoteProduct");
            }else{
                $('.requestquote-customerform-wrapper').hide();
                $('.thankyou-section .quote-success-icon').hide();
                $('.thankyou-section .quote-error-icon').show();
                $('.thankyou-section').addClass('show-thankyou-block');
                $('.thankyou-section h3').text(response.message);
                $('.thankyou-section .thankyou-submsg-txt').empty();
            }
            },
            error: function(error) {
            console.error("Error:", error);
            }
        });

        console.log("Submitted Data:", dataToSend);
        return false;
    });
}